import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Motion pre-states (hidden until revealed) only apply when this class is
// present, so visitors who prefer reduced motion always see everything.
if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
  document.documentElement.classList.add('motion');
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
